module.exports = "/img/_/_/_/assets/images/creeper/book/uncommon//11.jpg?a38ce4398410741df1a9360fd77e021d";